type NonFunctionPropertyNames<T> = { [K in keyof T]: T[K] extends Function ? never : K }[keyof T];

export function getPropertyNames<T>(defaultInstance: T): NonFunctionPropertyNames<T>[] {
	const memberNames = Object.getOwnPropertyNames(defaultInstance); // get all members of the instance
	const propertyNames = memberNames.filter(x => typeof (defaultInstance as any)[x] != "function"); // filter out functions
	return propertyNames as NonFunctionPropertyNames<T>[]; // cast as array of string union of non-function properties (ideally woudl be a string typed tuple but can't be done yet)
}